import { groq } from "next-sanity";
import { seoFields } from "../partials/shared";

export const termsPageQuery = groq`*[_type == "termsPage"][0] {
  pageTitle,
  _updatedAt,
  content,
}`;

export const termsPageSeoQuery = groq`
  *[_type == "termsPage"][0] {
    ${seoFields}
  }
`
